import useGameStore from '@/store';
import { useT } from '@/i18n/useLanguage';
import { Input } from '@chakra-ui/react/input';
import { useRef } from 'react';
import { LuSearch } from 'react-icons/lu';
import { useNavigate } from 'react-router';
import { InputGroup } from './input-group';

const SearchBox = () => {
	const ref = useRef<HTMLInputElement>(null);
	const setSearchText = useGameStore((s) => s.setSearchText);
	const t = useT();
	const navigate = useNavigate();

	return (
		<form
			style={{ width: '100%' }}
			onSubmit={(event) => {
				event.preventDefault();
				if (ref.current) {
					setSearchText(ref.current.value);
					navigate('/');
				}
			}}
		>
			<InputGroup startElement={<LuSearch opacity={0.6} />}>
				<Input
					ref={ref}
					placeholder={t('searchPlaceholder')}
					borderRadius="full"
					bg={{ _light: 'gray.100', _dark: 'whiteAlpha.100' }}
					borderWidth="1px"
					borderColor={{ _light: 'gray.200', _dark: 'whiteAlpha.200' }}
					_hover={{
						borderColor: { _light: 'gray.300', _dark: 'whiteAlpha.300' },
					}}
					_focusVisible={{
						borderColor: 'brand.400',
						boxShadow: '0 0 0 1px var(--chakra-colors-brand-400)',
					}}
					fontSize="sm"
				/>
			</InputGroup>
		</form>
	);
};

export default SearchBox;
